import { createActions, createReducer } from 'reduxsauce';
import { schema } from 'normalizr';
import {
  EXTEND_NORMALIZED_INITIAL_STATE,
  FAVOURITE_ACTIONS_SET,
  PAGINATED_ACTIONS_SET,
  getRequestHandler,
  getExtendNormalized,
  getSuccessListHandler,
  getFailureHandler,
  softRemoveHandler,
  toggleFavourite,
} from '../../../store/structures';
import { types as detailsTypes } from '../details/duck';

const coupon = new schema.Entity('coupons');

export const { Types: types, Creators: actions } = createActions(
  {
    getAllList: ['params'],
    getAllList: ['params'],
    getBrowseList: ['params'],
    resetCouponList: null,
    ...PAGINATED_ACTIONS_SET,
    ...FAVOURITE_ACTIONS_SET,
  },
  { prefix: 'cb/coupons/categorized/' },
);

export const HANDLERS = {
  [types.REQUEST]: getRequestHandler(EXTEND_NORMALIZED_INITIAL_STATE), // <-- non-clearing

  // Replace (first page)
  [types.SUCCESS]: getExtendNormalized(getSuccessListHandler, coupon),

  // Append (next pages)
  [types.SUCCESS_PAGINATED]: getExtendNormalized(
    getSuccessListHandler,
    coupon,
    { attach: true },
  ),

  [types.FAILURE]: getFailureHandler(),
  [detailsTypes.REMOVE_COUPON]: softRemoveHandler,
  [types.TOGGLE_FAVOURITE]: toggleFavourite,
  [types.RESET_COUPON_LIST]: () => EXTEND_NORMALIZED_INITIAL_STATE,
};

export default createReducer(EXTEND_NORMALIZED_INITIAL_STATE, HANDLERS);